import { render, staticRenderFns } from "./ImageStrip.vue?vue&type=template&id=10af0da5&scoped=true&lang=pug&"
import script from "./ImageStrip.vue?vue&type=script&lang=js&"
export * from "./ImageStrip.vue?vue&type=script&lang=js&"
import style0 from "./ImageStrip.vue?vue&type=style&index=0&id=10af0da5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af0da5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10af0da5')) {
      api.createRecord('10af0da5', component.options)
    } else {
      api.reload('10af0da5', component.options)
    }
    module.hot.accept("./ImageStrip.vue?vue&type=template&id=10af0da5&scoped=true&lang=pug&", function () {
      api.rerender('10af0da5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/ImageStrip.vue"
export default component.exports